import React from 'react';
import {EntypoChevronLeft} from 'react-entypo-icons';

export function Back({...rest}) {
  return <EntypoChevronLeft style={{fontSize: 35}} {...rest} />;
}
